import React from "react";
import "./style.scss";

const Arrow = ({direction, handleClick, slidesLength}) => (
  <div
    onClick={handleClick.bind(this, slidesLength)}
    className={`slider-arrow ${
      direction === "left" ? "left-direction" : "right-direction"
    }`}
  >
    {direction === "right" ? (
      <svg
        width="14px"
        height="22px"
        viewBox="0 0 14 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>video-slider-right-arrow</title>
        <desc>Created with Sketch.</desc>
        <defs></defs>
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="video-slider-right-arrow"
            transform="translate(-8.000000, 1.000000)"
            stroke-width="3"
            stroke="#FFFFFF"
          >
            <polyline
              id="Rectangle-6"
              transform="translate(9.936292, 9.936291) rotate(45.000000) translate(-9.936292, -9.936291) "
              points="3.3918746 3.39187389 16.4807094 3.39187389 16.4807094 16.4807087"
            ></polyline>
          </g>
        </g>
      </svg>
    ) : (
      <svg
        width="14px"
        height="22px"
        viewBox="0 0 14 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>video-slider-right-arrow</title>
        <desc>Created with Sketch.</desc>
        <defs></defs>
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="video-slider-right-arrow"
            transform="translate(12.000000, 11.000000) scale(-1, 1) translate(-12.000000, -11.000000) translate(2.000000, 1.000000)"
            stroke-width="3"
            stroke="#FFFFFF"
          >
            <polyline
              id="Rectangle-6"
              transform="translate(9.936292, 9.936291) rotate(45.000000) translate(-9.936292, -9.936291) "
              points="3.3918746 3.39187389 16.4807094 3.39187389 16.4807094 16.4807087"
            ></polyline>
          </g>
        </g>
      </svg>
    )}
  </div>
);

export default Arrow;
